import { useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "sonner";
import VenturePage from "./pages/VenturePage";
import { Preloader } from "./components/veerox/Preloader";
import { Cursor } from "./components/veerox/Cursor";
import { ScrollProgress } from "./components/veerox/ScrollProgress";
import { Ecosystem } from "./components/veerox/Ecosystem";
import { Capabilities } from "./components/veerox/Capabilities";
import { Journey } from "./components/veerox/Journey";
import { Navbar } from "./components/veerox/Navbar";
import { Hero } from "./components/veerox/Hero";
import { MarqueeStrip } from "./components/veerox/MarqueeStrip";
import { Manifesto } from "./components/veerox/Manifesto";
import { Ventures } from "./components/veerox/Ventures";
import { Stats } from "./components/veerox/Stats";
import { Contact } from "./components/veerox/Contact";
import { Footer } from "./components/veerox/Footer";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const Home = () => {
  const location = useLocation();
  useEffect(() => {
    const target = location.state?.scrollTo;
    if (!target) return;
    const t = setTimeout(() => {
      const el = document.querySelector(target);
      if (el && window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
    }, 200);
    return () => clearTimeout(t);
  }, [location.state]);

  return (
    <>
      <main className="relative z-10">
        <Hero />
        <MarqueeStrip />
        <Ecosystem />
        <Ventures />
        <Capabilities />
        <Manifesto />
        <Stats />
        <Journey />
        <Contact />
      </main>
      <Footer />
    </>
  );
};

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    const onAnchorClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const el = document.querySelector(a.getAttribute("href"));
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -70 });
      }
    };
    document.addEventListener("click", onAnchorClick);
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onAnchorClick);
      window.__lenis = null;
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain relative min-h-screen bg-[#020617] text-white">
      <BrowserRouter>
        <AnimatePresence>
          {loading && <Preloader onDone={() => setLoading(false)} />}
        </AnimatePresence>
        {!loading && (
          <>
            <Cursor />
            <ScrollProgress />
            <Navbar />
            <ScrollTop />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/ventures/:id" element={<VenturePage />} />
            </Routes>
          </>
        )}
        <Toaster position="bottom-right" theme="dark" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
